// extracted by mini-css-extract-plugin
export default {"container":"DraggableVerticalList_container__uquyo"};